import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AddBlock } from '@lyearn/molecules';
import { Box, Typography } from '@lyearn/ui';
import ScorecardCreatorModal from '@/modules/corporate/modules/scorecards/components/ScorecardCreatorModal';
import SelectScorecardsDialog from '@/modules/corporate/modules/scorecards/components/SelectScorecardsDialog';

import useExerciseScorecardManager, {
  SelectScorecardDialogStates,
} from '../../hooks/useExerciseScorecardManager';
import SelectedScorecards from './SelectedScorecards';

type AddScorecardsTypes = {
  selectedScorecardIds?: string[];
  onChange: (scorecardIds?: string[]) => void;
};

function AddScorecards({ onChange, selectedScorecardIds }: AddScorecardsTypes) {
  const { t } = useTranslation();
  const { state, methods } = useExerciseScorecardManager();
  const { selectScorecardDialogState } = state;
  const { setScorecardDialogState } = methods;
  const closeSelectScorecardDialog = useCallback(
    () => methods.setScorecardDialogState(null),
    [methods],
  );
  const showAddScorecardsDialog = useCallback(
    () => setScorecardDialogState(SelectScorecardDialogStates.SelectScorecards),
    [setScorecardDialogState],
  );
  const onCreateScorecard = useCallback(
    () => setScorecardDialogState(SelectScorecardDialogStates.CreateScorecard),
    [setScorecardDialogState],
  );

  return (
    <>
      <Box className="flex flex-col">
        <Typography className="mb-16 ms-8" variant="label-01">
          {t('Exercise:Creator.Scorecards')}
        </Typography>
        <SelectedScorecards selectedScorecardIds={selectedScorecardIds} onChange={onChange} />
        <AddBlock title={t('Exercise:Creator.AddScorecards')} onClick={showAddScorecardsDialog} />
      </Box>
      {selectScorecardDialogState === SelectScorecardDialogStates.SelectScorecards ? (
        <SelectScorecardsDialog
          selectedScorecardIds={selectedScorecardIds}
          onAttach={onChange}
          onClose={closeSelectScorecardDialog}
          onCreateScorecard={onCreateScorecard}
        />
      ) : null}
      {selectScorecardDialogState === SelectScorecardDialogStates.CreateScorecard ? (
        <ScorecardCreatorModal onClose={showAddScorecardsDialog} />
      ) : null}
    </>
  );
}

export default React.memo(AddScorecards);
